import { PTO_URL } from '@/api/pto/const'
import { createBaseResponseErrors, createUniqueError } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi, createCreateUniqueApi } from '@/api/base'

export const PTO_HANDBOOK_MEASURE_UNIT_URL = `${PTO_URL}/measure-unit`

const errors = {
  ...createBaseResponseErrors('ед. измерения', 'ед. измерения'),
  ...createUniqueError('Ед. измерения')
}

export const PTOHandbookMeasureUnitApi = {
  ...createBaseCRUDApi(PTO_HANDBOOK_MEASURE_UNIT_URL, errors),
  ...createCreateUniqueApi(PTO_HANDBOOK_MEASURE_UNIT_URL, errors)
}
